#require('../app/page_tab_navigation.coffee')
#require('../app/interactive_window.coffee')
require("slick-carousel")

class window.HistoryPage
  constructor: ()->
    @initSlider()

  initSlider: ->
    $('.history-slider--top').slick({
      prevArrow: $('.history-slider__arrow-back')
      nextArrow: $('.history-slider__arrow-next')
      centerPadding: '4%',
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: false,
      arrows: true,
      dots: true,
      infinite: false,
      initialSlide: 0,
      swipeToSlide: true,
      focusOnSelect: true,
      variableWidth: true,
      slide: '.history-slide'
      appendDots: ".slick-track",
      asNavFor: '.history-slider--bottom-container'
      responsive: [
        {
          breakpoint: 1104,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 752,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
          }
        }
      ]
    })

    $('.history-slider--bottom-container').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
      arrows: false,
      dots: false,
      infinite: false,
      asNavFor: '.history-slider--top'
      responsive: [
        {
          breakpoint: 752,
          settings: {
            infinite: true,
          }
        }
      ]
    })


// WEBPACK FOOTER //
// ./assets/javascripts/app/history-page.coffee